import { gql } from "@apollo/client";

export const BUILDING_ACCESSIBILITY_FIELDS_FRAGMENT = gql`
  fragment BuildingAccessibilityFieldsV2 on BuildingInterface {
    id
    slug
    accessibilityDetails
    amenities
    hasAccessibleImages
    hasAccessibleUnits
    hasElevator
    hasRollInShowers
    hasStepFreeEntrance
    hasWheelchairAccess
    images {
      id
      accessibilityFeatures
    }
    unitGroups {
      id
      unitType
      unitCount
      fcfsUnitCount
      bathroomCount
      mobilityAccessible
      visionAccessible
      hearingAccessible
      rentType
      ami
      minIncome
      rentalCost
      isAffordable
      __typename
    }
    __typename
  }
`;

export default BUILDING_ACCESSIBILITY_FIELDS_FRAGMENT;
